import React, { useEffect, useState, useContext } from 'react'
import { Button, Row, Col, Card, Modal, Image} from "react-bootstrap"
import { BsPlusCircleFill } from "react-icons/bs"
import { FaCalendar } from "react-icons/fa";
import { withTranslation } from "react-i18next"
import moment from 'moment'
import Get from '../../api/Get'
import Post from '../../api/Post'
import { GET_APPOINTMENTS_HISTORICAL, ADD_APPOINTMENT, DOCTOR_DINAMIC_SCHEDULE } from '../../api/Routes'
import { authContext } from "../../context/AuthContext";
import CardHistorialCitas from '../CardHistorialCitas';
import SimpleLoad from "../../loader/SimpleLoad";
import TableWithComponents from '../TableWithComponents';
import ComponentModalErrorSever from '../ComponentModalErrorSever';
import CardHorariosDoctor from '../doctor/CardHorariosDoctor';
import iconRecheck from '../../img/icons/recheck.svg'
import 'moment/locale/es'

function ProvHistorialCitas({t, cita, paciente, idDoctor, idPaciente,  notify, showAddCita=true}){
    const [items, setItems] = useState([])
    const [showForm, setShowForm] = useState(false)
    const [loading, setLoading] = useState(false)
    const [fechaCita, setFechaCita] = useState(null)
    const [dataCita, setDataCita] = useState(null)
    
    //nueva consulta por parte del doctor al paciente
    const [horario, setHorario] = useState(null)
    const days = paciente.company.id === 2 ? 3 : 7
    const [loadingHorarios,setLoadingHorarios] = useState(true)
    const [fecha, setFecha] = useState(new Date())
    const [indexSelectHor, setIndexSelectHor] = useState(null)
    const [itemHor, setItemHor] = useState(null)
    const [startDay, setStartDay] = useState(0)
    const [schedule, setSchedule] = useState(null)
    const [showSuccess, setShowSuccess] = useState(false);

    

    
    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)
    let accesToken = auth.data.access_token;

    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
        //history.replace("/admin")
    }
    const handleCloseSuccess = () => setShowSuccess(false);

    //Para traer todo el historial de citas
    useEffect(() => {
        let mounted = true;
        const url = `${GET_APPOINTMENTS_HISTORICAL}/${idDoctor}/${idPaciente}`
        setLoading(true)
        Get({url: url, access_token: accesToken})
        .then((resp) => {
            if(mounted){
                let data = resp.data.data.response;
                let elements = []

                data.forEach(element => {
                    if(element?.appointmentStatus === 'Pagada') {
                        let fecha = moment(element.scheduleDTO.dateTimeInit, "YYYY-MM-DDT:HH:mm:ss")
                        let after = moment().isAfter(fecha)

                        after && elements.push(element)
                    }
                });

                setItems(elements)
                setLoading(false)
            }  
        }).catch((error) => {
            setLoading(false)
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
        return () => mounted = false;
    }, [])

    //para os horarios del doctor
    useEffect(()=>{
        if(idDoctor){
            let mounted = true
            setLoadingHorarios(true)
            let url = `${DOCTOR_DINAMIC_SCHEDULE}?doctorId=${idDoctor}&dateIni=${moment(fecha).format("DD-MM-YYYY")}&dateEnd=${moment(fecha).format("DD-MM-YYYY")}&accountId=${paciente.account.id}`
            Post({url: url, data: {}, access_token: auth.data.access_token, header: true})
            .then(res=>{
                //console.log(res)
                if(mounted){
                    if(res.data.state){
                        let keys = Object.keys(res.data.data.response)
                        let obj ={
                            key: keys[0],
                            value: res.data.data.response[keys[0]]
                        }
                        //console.log(obj)
                        setHorario(obj)
                    }else{
                        setShowModalServer(true)
                        console.log(res.data.error)
                        let error = {
                            data: {
                                error: res.data.error
                            }
                        }
                        setErrorServer(error)
                    }
                    
                    setLoadingHorarios(false)
                }                
            })
            .catch(error=>{
                setLoadingHorarios(false)
                setShowModalServer(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
            return () => mounted = false;
        }
    }, [fecha])

    const onClickSelectedSchedule = (horario, doctorId) =>{        
        let schedule = {
            scheduleType:"Online",
            doctor: {
              id: doctorId
            },
            hourInit: moment(horario.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
        }
        setSchedule(schedule)
        onClickShowCitaPatient(schedule, idDoctor)
    }

    const selectTime = index =>{
        setItemHor(horario.value[index])
        setIndexSelectHor(index)  
        onClickSelectedSchedule(horario.value[index], idDoctor)      
    }
    const plusDay = n =>{
        let nDays = startDay+n
        setStartDay(nDays)        
        let newFecha = moment(fecha)
        newFecha.add(n, 'days')    
        setFecha(newFecha)        
    }
    const minusDay = n =>{
        let nDays = startDay-n
        setStartDay(nDays) 
        let newFecha = moment(fecha)
        newFecha.subtract(n, 'days')    
        setFecha(newFecha)
    }

    const handleShowForm = () => setShowForm(!showForm);

    const history = (cell, row) => {
        let fecha = moment(row.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss")
        let after = moment().isAfter(fecha)
        return after ? <CardHistorialCitas key={row.id} item={row} />: <div key={row.id}></div>
    }

    const columns = [
        {
            text: '',
            dataField: 'id',
            formatter: history
        }
    ]

    const onClickShowCitaPatient = (schedule, doctorId) =>{
        let fecha = moment(`${schedule.hourInit}`, "DD-MM-YYYY HH:mm:ss").format('LLLL')
        let data = {
            appointmentStatus: "Pagada",
            patient: {
              id: paciente.id,
              email:paciente.email
            },
            schedule: schedule,
            especialty: cita.speciality
        }
        setDataCita(data)
        setFechaCita(fecha)
    }
    
    const onClickEnviar = () =>{
        if(fechaCita){
            setLoading(true)
            Post({url: ADD_APPOINTMENT, data: dataCita, access_token:accesToken, header: true})
            .then(response=>{                
                setFechaCita(null)
                setFecha(new Date())
                setItemHor(null)
                setStartDay(0)
                setIndexSelectHor(null)
                setShowSuccess(true)
                setShowForm(!showForm)
                setLoading(false)
            })
            .catch(error=>{
                setLoading(false)
                setShowModalServer(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
        } else {
            alert('Seleccionar fecha por favor.')
        }
    }

    return (
        <div className='historical-citas-container p-3 pt-4 position-relative'>
            {loading && <SimpleLoad />}

            {
                !showForm 
                ? <>
                    {
                        showAddCita && <div className='cita-btn-add-container'  onClick={handleShowForm}>
                            <BsPlusCircleFill className="cita-btn-add-item"/> &nbsp;
                            <Button variant="outline-primary"  type="button" size="sm" > 
                                {t('crear_nueva_cita')}
                            </Button>{' '}
                        </div>
                    }

                    {
                        <TableWithComponents
                            onClickShowCitaPatient={()=>{console.log('CLICK')}}
                            columns={columns} 
                            items={items}
                        />
                    }
                </>
                : <>
                    <Row>
                        <Col>
                            {loadingHorarios && <SimpleLoad />}
                            {horario && <CardHorariosDoctor 
                                horario={horario} 
                                selectTime={selectTime}
                                indexSelect={indexSelectHor}
                                days={days}
                                plusDay={plusDay}
                                minusDay={minusDay}
                                startDay={startDay}
                            />}
                        </Col>
                    </Row>
                    <br/>
                    {
                        fechaCita && <Card className="shadow-1">
                            <Card.Body>
                                <p className='info-paciente'> {t('hora_asignada')} </p>
                                <br/>
                                <Card className='card-fecha-cita'>
                                    <Card.Body>
                                       <FaCalendar className='colorAzul'/>&nbsp; &nbsp; &nbsp;{fechaCita}
                                    </Card.Body>
                                </Card>
                            </Card.Body>
                        </Card>
                    }                   
                    <Row className="grupoBotones">
                        <Col>
                            <Button variant="danger" className="cancelar-buttom" type="button" onClick={handleShowForm}> {t('cancelar')} </Button>{' '}
                        </Col>
                        <Col className="text-right">
                            <Button variant="outline-success" className="ok-buttom" type="button" onClick={onClickEnviar} disabled={!fechaCita}> {t('crear')} </Button>{' '}
                        </Col>
                    </Row>
                </>
            }
            <ComponentModalErrorSever
                show={showModalServer}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />
            <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
                <Modal.Body className="p-0">
                    <div className="text-center position-relative overflow-hidden h-100p">
                        <Image src={iconRecheck} fluid className="img-recheck"/>
                        <h5 className="mb-0 text-app-success">{t('solicitud_exitosa')}</h5>
                    </div>                
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default withTranslation()(ProvHistorialCitas)
